import React from 'react';
import { floatRenderer, percentageRenderer } from '../../../../services/formatSvc';
import OriginalTooltippedElement from '../../../common/TooltippedElement';
import { getStickyColumns } from '../../../../helpers/table.jsx';


const TOOLTIP_TEXT = `- для уровней Проект, Соглашение, Тип финансирования, КБК - рассчитывается от значений в столбце  "Одобренный бюджет проекта на ЭГ, руб.";\n
- для уровней Закупка, КВР - рассчитывается от значений в столбце  "Утверждено на комиссии по расходованию/введено по сз ректору, руб."`;

const CELL_STYLES = {
  money: { minWidth: '150px', textAlign: 'center' },
  percents: { minWidth: '75px', textAlign: 'center' },
};

function TooltippedElement(props) {
  return (
    <div>
      <OriginalTooltippedElement tooltip={TOOLTIP_TEXT} newLineIcon>
        {props.children}
      </OriginalTooltippedElement>
    </div>
  );
}

export const getColumns = () => { 
  const colsLeft = [
    {
      field: 'num',
      title: 'Соглашение/Тип финансирования/КБК/Закупки/КВР',
      cellStyle: { textAlign: 'center' },
      width: '160px',
    },
    {
      field: 'name',
      title: 'Наименование источника/типа финансирования/КБК/статьи затрат',
      cellStyle: (value, { category }) => ({
        textAlign: !['buy', 'kvr'].includes(category) ? 'center' : undefined,
      }),
      width: '300px',
    },
  ]

  const colsMiddle = [
    {
      field: 'recentPlanSum',
      title: 'Введено по проекту, руб.',
      render: ({ recentPlanSum }) => new Intl.NumberFormat("ru", { minimumFractionDigits: 2 }).format(recentPlanSum),
      cellStyle: CELL_STYLES.money,
    },
    {
      field: 'planSum',
      title: 'Одобренный бюджет проекта на ЭГ, руб.',
      render: ({ planSum }) => new Intl.NumberFormat("ru", { minimumFractionDigits: 2 }).format(planSum),
      cellStyle: CELL_STYLES.money,
    },
    {
      field: 'draftSum',
      title: 'Введено по закупкам, руб.',
      render: ({ draftSum }) => new Intl.NumberFormat("ru", { minimumFractionDigits: 2 }).format(draftSum),
      cellStyle: CELL_STYLES.money,
    },
    {
      field: 'approvedSum',
      title: 'Утверждено на комиссии по расходованию/введено по сз ректору, руб.',
      render: ({ approvedSum }) => new Intl.NumberFormat("ru", { minimumFractionDigits: 2 }).format(approvedSum),
      cellStyle: CELL_STYLES.money,
    },
    {
      field: 'approvedPercent',
      title: '% сумма утверждено на комиссии',
      render: ({ approvedPercent }) => percentageRenderer(approvedPercent),
      cellStyle: CELL_STYLES.percents,
    },
    {
      field: 'acceptedSum',
      title: 'Акцепт ПФУ, руб.',
      render: ({ acceptedSum }) => new Intl.NumberFormat("ru", { minimumFractionDigits: 2 }).format(acceptedSum),
      cellStyle: CELL_STYLES.money,
    },
    {
      field: 'acceptedPercent',
      title: <TooltippedElement>% акцепта</TooltippedElement>,
      render: ({ acceptedPercent }) => percentageRenderer(acceptedPercent),
      cellStyle: CELL_STYLES.percents,
    },
    {
      field: 'contractSum',
      title: 'Контрактная стоимость, руб.',
      render: ({ contractSum }) => new Intl.NumberFormat("ru", { minimumFractionDigits: 2 }).format(contractSum),
      cellStyle: CELL_STYLES.money,
    },
    {
      field: 'contractPercent',
      title: <TooltippedElement>% контрактации</TooltippedElement>,
      render: ({ contractPercent }) => percentageRenderer(contractPercent),
      cellStyle: CELL_STYLES.percents,
    },
    {
      field: 'paymentSum',
      title: 'Оплата, руб.',
      render: ({ paymentSum }) => new Intl.NumberFormat("ru", { minimumFractionDigits: 2 }).format(paymentSum),
      cellStyle: CELL_STYLES.money,
    },
    {
      field: 'paymentPercent',
      title: <TooltippedElement>% оплаты</TooltippedElement>,
      render: ({ paymentPercent }) => percentageRenderer(paymentPercent),
      cellStyle: CELL_STYLES.percents,
    },
    {
      field: 'approvedLeft',
      title: <TooltippedElement>Не утверждено по закупкам, руб.</TooltippedElement>,
      render: ({ approvedLeft }) => new Intl.NumberFormat("ru", { minimumFractionDigits: 2 }).format(approvedLeft),
      cellStyle: CELL_STYLES.money,
    },
    {
      field: 'acceptedLeft',
      title: <TooltippedElement>Не акцептовано ПФУ, руб.</TooltippedElement>,
      render: ({ acceptedLeft }) => new Intl.NumberFormat("ru", { minimumFractionDigits: 2 }).format(acceptedLeft),
      cellStyle: CELL_STYLES.money,
    },
    {
      field: 'contractLeft',
      title: <TooltippedElement>Не законтрактовано, руб.</TooltippedElement>,
      render: ({ contractLeft }) => new Intl.NumberFormat("ru", { minimumFractionDigits: 2 }).format(contractLeft),
      cellStyle: CELL_STYLES.money,
    },
    {
      field: 'paymentLeft',
      title: <TooltippedElement>Не оплачено, руб.</TooltippedElement>,
      render: ({ paymentLeft }) => new Intl.NumberFormat("ru", { minimumFractionDigits: 2 }).format(paymentLeft),
      cellStyle: CELL_STYLES.money,
    },
  ]

  return [...getStickyColumns(colsLeft, 48), ...colsMiddle];
};
